// tslint:disable
declare const window: any
import * as qs from 'qs'

export function renderPopular(num: number) {
  if (num < 1e4) {
    return num
  } else {
    return `${+(num / 1e4).toFixed(1)}万`
  }
}

// 判断是否是荔枝微课APP打开--用于webview
export function isLZWKAPP() {
  if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())) {
    return true
  } else {
    return false
  }
}

export function getToken() {
  const token = localStorage.getItem('_token') || ''
  return token
}

export function setToken(token: string) {
  localStorage.setItem('_token', token)
  return token
}

export function isPC() {
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
    return false
  } else {
    return true
  }
}

export function isIphone () {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //判断iPhone|iPad|iPod|iOS
    return true;
  }
  return false;
};

export function isIphoneX() {
  return /iphone/gi.test(navigator.userAgent) && screen.height === 812 && screen.width === 375
}

export function getJsonFromUrl(path?: string) {
  const query = path && path.split('?')[1] ? path.split('?')[1] : window.location.search.substr(1)
  const result: any = {}
  query.split('&').forEach((part: any) => {
    const item = part.split('=')
    result[item[0]] = decodeURIComponent(item[1])
  })
  return result
}

export function getUrlParam(targetParam: string) {
  const url = document.location.href
  const param = url.split('?')[1]
  const result = new URLSearchParams('?' + param)
  return result.get(targetParam)
}

export function getUnifyTextLen(str: string) {
  return str.replace(/[^\x00-\xff]/g, '01').length
}

export function pathTo(history: any, path: string) {
  history.push(path)
}

function getScrollTopElement(): HTMLElement {
  return document.documentElement as HTMLElement
}

function publicAnimation() {
  const currentScroll = getScrollTopElement().scrollTop || document.body.scrollTop
  if (currentScroll > 0) {
    window.requestAnimationFrame(() => publicAnimation())
    window.scrollTo(0, currentScroll - currentScroll / 5)
  }
}

export function backToTop() {
  publicAnimation()
}

export function deletePictureParams(str: string) {
  try {
    let len: number = 0
    if (str.lastIndexOf('jpg') > -1) {
      len = str.lastIndexOf('jpg') + 3
      return str.substr(0, len)
    } else if (str.lastIndexOf('png') > -1) {
      len = str.lastIndexOf('png') + 3
      return str.substr(0, len)
    } else if (str.lastIndexOf('jpeg') > -1) {
      len = str.lastIndexOf('jpeg') + 4
      return str.substr(0, len)
    } else if (str.lastIndexOf('JPEG') > -1) {
      len = str.lastIndexOf('JPEG') + 4
      return str.substr(0, len)
    } else if (str.lastIndexOf('PNG') > -1) {
      len = str.lastIndexOf('PNG') + 3
      return str.substr(0, len)
    } else if (str.lastIndexOf('JPG') > -1) {
      len = str.lastIndexOf('JPG') + 3
      return str.substr(0, len)
    } else {
      return str
    }
  } catch (e) {
    console.log(e)
    return str
  }
}

export function TimeStream(timestamp: number, type?: string) {
  const date: Date = new Date(timestamp * 1000)
  const Y = date.getFullYear()
  const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  const nowTime: Date = new Date()
  const timeToString = nowTime.toString()
  switch (type) {
    case 'YM': // 年-月
      return Y + '-' + M
    case 'MD': // 月-日
      return M + '-' + D
    case 'MD_HM': // 月-日
      return M + '-' + D + ' ' + h + ':' + m
    case 'YMD_HMS': // 月-日 时：分：秒
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
    case 'CN_YMD': // x年x月x日
      return Y + '.' + M + '.' + D + '.'
    case 'CN_YMD_HM': // x年x月x日
      return Y + '.' + M + '.' + D + ' ' + h + ':' + m
    case 'CN_MD_HM': // x月x日
      return M + '.' + D + '.' + ' ' + h + ':' + m
    case 'hm': // 时:分
      return h + ':' + m
    case '-D': // 天数差
      return Math.floor((timestamp * 1000 - Date.parse(timeToString)) / 1000 / 3600 / 24)
    case '-H': // 小时差
      return Math.ceil((timestamp * 1000 - Date.parse(timeToString)) / 1000 / 3600)
    default:
      // 年-月-日 时:分
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m
  }
}

export function mta(payload: string) {
  window.MtaH5 && window.MtaH5.clickStat(payload)
  window._czc && window._czc.push(['_trackEvent', 'common', 'click', payload, 1])
}

export function trim(str: string) {
  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
}

export function getPicture(url: string, width: number = 300, format: string = 'normal', quality: number = 85) {
  if (format === 'webp') {
    return `${deletePictureParams(url)}?imageView2/format/webp/2/w/${width}/q/${quality}!`
  } else {
    return `${deletePictureParams(url)}?imageView2/2/w/${width}/q/${quality}!`
  }
}

export function setEvent(params: { page?: string; category?: string; action?: string; label?: string; value?: string }) {
  ;(window as any)._czc && (window as any)._czc.push(['_trackEvent', params.page || 'common', params.category || 'click', params.action || '', params.label || 1, params.value])
}

export async function cnzzSendObjectEvent(params: { page?: string; category?: string; action?: string; label?: string; value?: string }) {
  setEvent(params)
}

export function isIOS() {
  return /(iPhone|iPod|ios)/i.test(navigator.userAgent)
}

export function isAndroid() {
  return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
}

export function getPlatform() {
  if (isIOS()) {
    return 'ios'
  } else if (isAndroid()) {
    return 'android'
  } else {
    return 'pc'
  }
}

export function getPlatformNumber() {
  if (isIOS()) {
    return '0'
  } else if (isAndroid()) {
    return '1'
  } else {
    return '2'
  }
}

/**
 *  节流，一定时间范围内只要第一次
 * @param delay
 */
export const throttle = (() => {
  let timer: NodeJS.Timeout | null
  return (fn: Function, delay: number = 500) => {
    return (...rest: any) => {
      if (timer) {
        return
      }
      timer = setTimeout(() => (timer = null), delay)
      fn(...rest)
    }
  }
})()

/**
 *  防抖，一定时间范围内只要最后一次
 * @param delay
 */
export const debounce = (() => {
  let timer: NodeJS.Timeout | null
  return (fn: Function, delay: number = 500) => {
    return (...rest: any) => {
      timer && clearTimeout(timer)
      return new Promise(resolve => {
        timer = setTimeout(() => {
          resolve(fn(...rest))
        }, delay)
      })
    }
  }
})()

export function getLocationParams() {
  return qs.parse(window.location.search.replace('?', ''))
}

export function getLocationParamValue(key: string): string | any {
  return qs.parse(window.location.search.replace('?', ''))[key] || ''
}

export function isTest(): boolean {
  return /(dbg.lizhiweike.com)|(localhost)/.test(window.location.host)
}



// WEBPACK FOOTER //
// ./src/utils/tools.ts